import { render } from "./Scanner.vue?vue&type=template&id=35f6f4ae"
import script from "./Scanner.vue?vue&type=script&lang=js"
export * from "./Scanner.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__